module.exports = new __parcel__URL__("taxaroo-logo.7a3ce4e2.png").toString();